const gql = {
  query: `mutation updateTACommPrefCustomer(
        $body: GspCommunicationsPutRequestDTOInput!
        $customerIds: String,
        $prevEmailAddress: String
      ) {
        putCommPrefCustomer(body: $body, customerIds: $customerIds, prevEmailAddress: $prevEmailAddress) {
          empty
        }
      }`,
  variables: {
    body: null,
    customerIds: null,
    prevEmailAddress: null,
  },
  meta: {
    label: "Update Communication Preference",
  },
};

export default gql;
